<!--
  管理端登录页。

  ⚠️ 输入框必须带 name + autocomplete：页面里没有 <form>，浏览器只能靠这两个
     属性识别账号 / 密码，否则密码管理器不会正确填充。
  ⚠️ 登录失败必须抛出：吞掉会让界面停在登录页而用户以为还在加载。
-->
<template>
  <div class="adm-login">
    <section class="adm-login-brand">
      <div class="adm-login-brand-inner">
        <div class="adm-login-logo">
          <span class="adm-logo-mark">TB</span>
          <span class="adm-login-logo-text">TaskBlock 运营管理后台</span>
        </div>

        <h1 class="adm-login-title">管理 TaskBlock 的<br />用户、内容与成长体系</h1>
        <p class="adm-login-desc">
          TaskBlock 是「时间块 + 随想 + 任务 + 工作区」的个人效率工具。
          本后台面向内部运营与运维，负责 C 端账号治理、内容审核、邀请码发放、
          成就体系维护与全局设置调整。
        </p>

        <div class="adm-login-points">
          <div class="adm-login-point">
            <i class="el-icon-check" />用户管理：查询账号、禁用异常用户，禁用即时生效
          </div>
          <div class="adm-login-point">
            <i class="el-icon-check" />内容审核：下架 / 恢复随想、分享评论与分享链接
          </div>
          <div class="adm-login-point">
            <i class="el-icon-check" />邀请码与成就：批量发码，维护解锁条件与上下架
          </div>
          <div class="adm-login-point">
            <i class="el-icon-check" />系统设置与操作日志：改完即时生效，全部写操作留痕
          </div>
        </div>
      </div>

      <div class="adm-login-brand-foot">
        TaskBlock · 内部系统，请勿对外分享入口地址
      </div>
    </section>

    <section class="adm-login-panel">
      <div class="adm-login-form">
        <div class="adm-login-form-title">账号登录</div>
        <div class="adm-login-form-sub">请输入管理员用户名与密码</div>

        <div class="adm-login-field">
          <label class="adm-login-field-label" for="admin-username">用户名</label>
          <el-input
            id="admin-username"
            v-model="form.username"
            name="username"
            autocomplete="username"
            placeholder="请输入用户名"
            @keyup.enter.native="onSubmit"
          >
            <i slot="prefix" class="el-icon-user" />
          </el-input>
        </div>

        <div class="adm-login-field">
          <label class="adm-login-field-label" for="admin-password">密码</label>
          <el-input
            id="admin-password"
            v-model="form.password"
            name="password"
            type="password"
            autocomplete="current-password"
            placeholder="请输入密码"
            show-password
            @keyup.enter.native="onSubmit"
          >
            <i slot="prefix" class="el-icon-lock" />
          </el-input>
        </div>

        <button
          class="adm-login-submit"
          :class="{ 'is-loading': loading }"
          :disabled="loading"
          @click="onSubmit"
        >
          {{ loading ? '登录中…' : '登 录' }}
        </button>

        <div class="adm-login-tip">
          连续 3 次密码错误将锁定 30 分钟。<br />
          忘记密码需联系其他管理员重置。
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { adminLogin, setAdminToken, isOk } from '@/api/admin'

export default {
  name: 'AdminLogin',
  data() {
    return {
      form: { username: '', password: '' },
      loading: false
    }
  },
  methods: {
    onSubmit() {
      if (this.loading) return
      if (!this.form.username.trim()) {
        this.$message.warning('请输入用户名')
        return
      }
      if (!this.form.password) {
        this.$message.warning('请输入密码')
        return
      }
      this.loading = true
      adminLogin(this.form.username.trim(), this.form.password)
        .then(res => {
          if (!isOk(res)) {
            throw new Error(res && res.message ? res.message : '登录失败')
          }
          setAdminToken(res.data.token)
          this.$emit('login-success', res.data)
        })
        .catch(err => {
          this.$message.error(err.message || '登录失败')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
